import { render } from "./Filterable-Option.vue?vue&type=template&id=63338a09&scoped=true"
import script from "./Filterable-Option.vue?vue&type=script&lang=js"
export * from "./Filterable-Option.vue?vue&type=script&lang=js"

import "./Filterable-Option.vue?vue&type=style&index=0&id=63338a09&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63338a09"

export default script